<template>
  <div
    v-if="block"
    class="cursor-move"
    data-block="Premade"
    :data-blockindex="blockIndex"
    :data-blocktype="blockType"
  >
    <img
      v-if="src"
      class="w-[340px]"
      :class="{ clickable: clickable }"
      :src="src"
    />
    <t-button v-else style="width: 100%; margin-bottom: 12px; cursor: move">{{
      block.name
    }}</t-button>
    <div>
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { TButton } from "@topol/twig-ui";
  import { computed } from "vue";

  const props = defineProps({
    block: {
      type: Object,
      required: true,
    },

    blockIndex: {
      type: Number,
      required: true,
    },

    blockType: {
      type: Number,
      required: true,
    },

    clickable: {
      type: Boolean,
      default: false,
    },
  });

  const src = computed(() => {
    return props.block ? props.block.img : "";
  });
</script>
<style lang="scss"></style>
